import React from 'react';

import { postLeaveData, updateLeaveData } from '../../service/adminApi';
import { OnlyNumberSpecialChar } from '../../utils/RegHandling';

let defaultValue = {
    type: '',
    count: '',
    Q1: '',
    Q2: '',
    Q3: '',
    Q4: '',
    is_attachment: false,
    is_availability: false,
    is_dependency: false,
    description: '',
};

let defaultValueError = {
    leaveTypeError: '',
    leaveCountError: '',
    q1Error: '',
    q2Error: '',
    q3Error: '',
    q4Error: '',
};

function LeaveForm({ editData, handleData, hideContainer }) {
    const [leaveError, setLeaveError] = React.useState(defaultValueError);
    const [showNavBar, setShowNavbar] = React.useState(false);
    const [leaveData, setLeaveData] = React.useState(defaultValue);

    React.useEffect(() => {
        if (editData.type != undefined) {

            let leave = {
                type: editData.type,
                count: editData.count,
                Q1: editData.quarter['1'],
                Q2: editData.quarter['2'],
                Q3: editData.quarter['3'],
                Q4: editData.quarter['4'],
                is_attachment: editData.is_attachment,
                is_availability: editData.is_availability,
                is_dependency: editData.is_dependency,
                description: editData.description,
            };
            setLeaveData(leave);
        }
    }, [editData]);

    const resetData = () => {
        setLeaveData(defaultValue);
        setLeaveError(defaultValueError);
        handleData('cancel');
        hideContainer();
    };

    const postLeave = () => {
        if (validateLeaveForm()) {
            let leave = {
                type: leaveData.type,
                count: leaveData.count,
                leave_quarter: { 1: leaveData.Q1, 2: leaveData.Q2, 3: leaveData.Q3, 4: leaveData.Q4 },
                is_attachment: leaveData.is_attachment,
                is_availability: leaveData.is_availability,
                is_dependency: leaveData.is_dependency,
                description: leaveData.description,
            };

            setShowNavbar(true);
            if (editData?.id === undefined) {
                postLeaveData(leave).then((res) => {
                    if (res.data.statusCode == 200) {
                        resetData();
                        handleData('update');
                        setShowNavbar(false);
                    }
                });
            } else if (editData?.id !== undefined) {
                leave['leave_id'] = editData.id;
                updateLeaveData(leave).then((res) => {
                    if (res.data.statusCode == 200) {
                        handleData('update');
                        resetData();
                    }
                });
            }
        }
    };

    const validateLeaveForm = () => {
        let result = true;
        if (leaveData.type === undefined || leaveData.type === '') {
            setLeaveError((leaveError) => ({ ...leaveError, leaveTypeError: 'Leave Title is required' }));
            result = false;
        }
        if (OnlyNumberSpecialChar(leaveData.type)) {
            setLeaveError((leaveError) => ({ ...leaveError, leaveTypeError: 'Enter a valid title' }));
            result = false;
        }
        if (leaveData.type.length > 25) {
            setLeaveError((leaveError) => ({ ...leaveError, leaveTypeError: 'Title must be at least 25 characters' }));
            result = false;
        }
        if (leaveData.count === undefined || leaveData.count === '') {
            setLeaveError((leaveError) => ({ ...leaveError, leaveCountError: 'Leave Count is required' }));
            result = false;
        }
        if (leaveData.Q1 === '' || leaveData.Q1 === null || leaveData.Q1 === undefined) {
            setLeaveError((leaveError) => ({ ...leaveError, q1Error: 'Enter Q1' }));
            result = false;
        }
        if (leaveData.Q2 === '' || leaveData.Q2 === null || leaveData.Q2 === undefined) {
            setLeaveError((leaveError) => ({ ...leaveError, q2Error: 'Enter Q2' }));
            result = false;
        }
        if (leaveData.Q3 === '' || leaveData.Q3 === null || leaveData.Q3 === undefined) {
            setLeaveError((leaveError) => ({ ...leaveError, q3Error: 'Enter Q3' }));
            result = false;
        }
        if (leaveData.Q4 === '' || leaveData.Q4 === null || leaveData.Q4 === undefined) {
            setLeaveError((leaveError) => ({ ...leaveError, q4Error: 'Enter Q4' }));
            result = false;
        }
        if (parseInt(leaveData.count) == 0) {
            result = false;
            setLeaveError((leaveError) => ({
                ...leaveError,
                leaveCountError: 'The Quarter Count should be greater than zero.',
            }));
        } else if (isNaN(leaveData.Q1)) {
            setLeaveError((leaveError) => ({ ...leaveError, q1Error: 'Enter Number' }));
            result = false;
        } else if (isNaN(leaveData.Q2)) {
            setLeaveError((leaveError) => ({ ...leaveError, q2Error: 'Enter Number' }));
            result = false;
        } else if (isNaN(leaveData.Q3)) {
            setLeaveError((leaveError) => ({ ...leaveError, q3Error: 'Enter Number' }));
            result = false;
        } else if (isNaN(leaveData.Q4)) {
            setLeaveError((leaveError) => ({ ...leaveError, q4Error: 'Enter Number' }));
            result = false;
        } else if (
            parseInt(leaveData.count) !==
            parseInt(leaveData.Q1) + parseInt(leaveData.Q2) + parseInt(leaveData.Q3) + parseInt(leaveData.Q4)
        ) {
            result = false;
            setLeaveError((leaveError) => ({
                ...leaveError,
                leaveCountError: 'The Quarter Count and the leave count should be equal.',
            }));
        }
        if (result === false) setShowNavbar(false);
        return result;
    };

    return (
        <>
            <div className="offcanvas-header">
                <h5 className=" tt-bold font-16 announcement-offcanvas-color">
                    {editData?.type == undefined ? `Create a leave Type` : `Edit Leave`}
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                        resetData();
                    }}
                />
            </div>
            <div className="offcanvas-body">
                <div className="row">
                    <div className="col-md-12 pb-5 mb-3">
                        <div className="row">
                            <div className="col-md-6 mb-4">
                                <label className="form-label font-13 bold-text  announcement-offcanvas-color" htmlFor="Announcement-Title">
                                    Leave Type
                                    <span className="required"> *</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control custom-textfield regular-text font-13"
                                    id="Announcement-Title"
                                    value={leaveData.type}
                                    placeholder="Title"
                                    maxLength={30}
                                    onChange={(e) => {
                                        setLeaveError((leaveError) => ({ ...leaveError, leaveTypeError: '' }));
                                        setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: e.target.value }));
                                        setShowNavbar(true);
                                    }}
                                    autoComplete="off"
                                    name="type"
                                />
                                <span className="text-danger">{leaveError.leaveTypeError}</span>
                            </div>
                            <div className="col-md-6 mb-4">
                                <label className="form-label font-13 bold-text  announcement-offcanvas-color" htmlFor="Add-description">
                                    Leave Count
                                    <span className="required"> *</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control custom-textfield regular-text font-13"
                                    id="Add-description"
                                    rows={6}
                                    maxLength={3}
                                    value={leaveData.count}
                                    onChange={(e) => {
                                        setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: e.target.value }));
                                        setLeaveError((leaveError) => ({ ...leaveError, leaveCountError: '' }));
                                        setShowNavbar(true);
                                    }}
                                    name="count"
                                    placeholder="Leave Count"
                                />
                                <span className="text-danger">{leaveError.leaveCountError}</span>
                            </div>
                        </div>
                        <div className="col-md-12 mb-4">
                            <p className="font-13 bold-text  leave-offcanvas-color">
                                Leave for each Quarter
                                <span className="required"> *</span>
                            </p>
                            <div className="col-md-4"></div>
                            <div className="d-flex">
                                <div className="col-md-3 d-flex align-items-center">
                                    <label className="form-label font-15 semibold-text leave-qlabel-color mb-0 me-3" htmlFor="q1">
                                        Q1
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control leave-qlabel-box"
                                        id="q1"
                                        maxLength={3}
                                        name="Q1"
                                        rows={6}
                                        value={leaveData.Q1}
                                        placeholder
                                        onChange={(e) => {
                                            setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: e.target.value }));
                                            setLeaveError((leaveError) => ({ ...leaveError, q1Error: '' }));
                                            setShowNavbar(true);
                                        }}
                                    />
                                    <span className="text-danger">{leaveError.q1Error}</span>
                                </div>
                                <div className="col-md-3 d-flex align-items-center">
                                    <label className="form-label font-15 semibold-text leave-qlabel-color mb-0 me-3" htmlFor="q2">
                                        Q2
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control leave-qlabel-box"
                                        id="q2"
                                        rows={6}
                                        maxLength={3}
                                        name="Q2"
                                        value={leaveData.Q2}
                                        placeholder
                                        onChange={(e) => {
                                            setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: e.target.value }));
                                            setLeaveError((leaveError) => ({ ...leaveError, q2Error: '' }));
                                            setShowNavbar(true);
                                        }}
                                    />
                                    <span className="text-danger">{leaveError.q2Error}</span>
                                </div>
                                <div className="col-md-3 d-flex align-items-center">
                                    <label className="form-label font-15 semibold-text leave-qlabel-color mb-0 me-3" htmlFor="q3">
                                        Q3
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control leave-qlabel-box"
                                        id="q3"
                                        maxLength={3}
                                        name="Q3"
                                        value={leaveData.Q3}
                                        rows={6}
                                        placeholder
                                        onChange={(e) => {
                                            setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: e.target.value }));
                                            setLeaveError((leaveError) => ({ ...leaveError, q3Error: '' }));
                                            setShowNavbar(true);
                                        }}
                                    />
                                    <span className="text-danger">{leaveError.q3Error}</span>
                                </div>
                                <div className="col-md-3 d-flex align-items-center">
                                    <label className="form-label font-15 semibold-text leave-qlabel-color mb-0 me-3" htmlFor="q4">
                                        Q4
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control leave-qlabel-box"
                                        id="q4"
                                        rows={6}
                                        placeholder
                                        maxLength={3}
                                        name="Q4"
                                        value={leaveData.Q4}
                                        onChange={(e) => {
                                            setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: e.target.value }));
                                            setLeaveError((leaveError) => ({ ...leaveError, q4Error: '' }));
                                            setShowNavbar(true);
                                        }}
                                    />
                                    <span className="text-danger">{leaveError.q4Error}</span>
                                </div>
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="font-13 bold-text  leave-offcanvas-color">Does attachments needed in the leave form?</label>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input leave-toggle mt-2"
                                    type="checkbox"
                                    id="flexSwitchCheckChecked"
                                    name="is_attachment"
                                    value={leaveData.is_attachment}
                                    checked={leaveData.is_attachment}
                                    onChange={(e) => {
                                        setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: !leaveData.is_attachment }));
                                        setShowNavbar(true);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="font-13 bold-text  leave-offcanvas-color">
                                Does availability info needed in the leave form?
                            </label>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input leave-toggle mt-2"
                                    type="checkbox"
                                    id="flexSwitchCheckChecked"
                                    name="is_availability"
                                    value={leaveData.is_availability}
                                    checked={leaveData.is_availability}
                                    onChange={(e) => {
                                        setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: !leaveData.is_availability }));
                                    }}
                                />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="font-13 bold-text  leave-offcanvas-color">Does dependency needed in the leave form?</label>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input leave-toggle mt-2"
                                    type="checkbox"
                                    id="flexSwitchCheckChecked"
                                    value={leaveData.is_dependency}
                                    name="is_dependency"
                                    checked={leaveData.is_dependency}
                                    onChange={(e) => {
                                        setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: !leaveData.is_dependency }));
                                    }}
                                />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="form-label font-13 bold-text  announcement-offcanvas-color" htmlFor="Leave-description">
                                Leave description
                            </label>
                            <textarea
                                className="form-control leave-box-size regular-text font-13"
                                id="Leave-description"
                                rows={6}
                                placeholder="Description"
                                maxLength={255}
                                name="description"
                                value={leaveData.description}
                                onChange={(e) => {
                                    setLeaveData((leaveData) => ({ ...leaveData, [e.target.name]: e.target.value }));
                                }}
                            />
                        </div>
                        <div className='row'>
                        <div className="text-end pb-3 px-0 mt-5 bg-white custom-button-position ">
                            <button
                                onClick={() => {
                                    resetData();
                                }}
                                className="btn hive-btn-secondary me-3"
                            // data-bs-dismiss={'offcanvas'}
                            // aria-label="Close"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => {
                                    postLeave();
                                }}
                                // data-bs-dismiss={showNavBar == true ? 'offcanvas' : 'dummy'}
                                // aria-label="Close"
                                className="btn medium-text font-14 primary-button me-3"
                            >
                                {editData?.type == undefined ? 'Create Leave' : 'Update Leave'}
                            </button>
                        </div>
                        </div>
                    </div>
                </div>
                {/*offcanvas body ends here*/}
            </div>
        </>
    );
}

export default LeaveForm;
